    <div class="row">
        <div class="col-md-12 list-padding-bottom">
            <app-community-member-filter-connections 
                [filterType]="filterType" 
                [memberCountData]="memberCountData">
            </app-community-member-filter-connections>
        </div>
    </div>